var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2065 0.203125L12.7391 0.209886L13.0025 0.210691L18.4928 5.61667V17.7039C18.4928 18.684 17.6719 19.4786 16.6593 19.4786H5.65822C4.6456 19.4786 3.82471 18.684 3.82471 17.7039V1.98536C3.82471 1.00524 4.6456 0.210691 5.65822 0.210691L12.2056 0.209886L12.2065 0.203125ZM12.2058 1.22656L5.6584 1.22737C5.22442 1.22737 4.87261 1.56789 4.87261 1.98794V17.7065C4.87261 18.1265 5.22442 18.467 5.6584 18.467H16.6595C17.0934 18.467 17.4452 18.1265 17.4452 17.7065V6.3317L14.0402 6.29786C13.0275 6.29786 12.2066 5.50331 12.2066 4.52319L12.2058 1.22656ZM13.2558 4.52378V1.9082L16.7124 5.31138L14.0471 5.28438C13.6076 5.28436 13.2558 4.94383 13.2558 4.52378Z",
    fill: "#47FDCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38175 4.51953L8.91434 4.52629L9.17779 4.5271L14.6681 9.93308V22.0203C14.6681 23.0004 13.8472 23.795 12.8346 23.795H1.83351C0.82089 23.795 0 23.0004 0 22.0203V6.30177C0 5.32165 0.82089 4.5271 1.83351 4.5271L8.38088 4.52629L8.38175 4.51953ZM8.38062 5.54297L1.83325 5.54377C1.39927 5.54377 1.04746 5.88429 1.04746 6.30435V22.0229C1.04746 22.4429 1.39927 22.7835 1.83325 22.7835H12.8343C13.2683 22.7835 13.6201 22.4429 13.6201 22.0229V10.6481L10.215 10.6143C9.20239 10.6143 8.3815 9.81972 8.3815 8.83959L8.38062 5.54297ZM9.43068 8.84019V6.22461L12.8873 9.62779L10.222 9.60079C9.78249 9.60076 9.43068 9.26024 9.43068 8.84019Z",
    fill: "#47FDCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorCopy);
export default __webpack_public_path__ + "static/media/color-copy.fe1346ecbdc6396bee5fc5734879c485.svg";
export { ForwardRef as ReactComponent };